<template>
  <div>
    <v-container fluid class="d-flex justify-space-between align-center">
      <div class="report_section">
        <h1 class="title_page">Reports</h1>
        <v-btn color="primary" class="export-btn" @click="exportReports">
          <v-icon class="mr-2">mdi-download</v-icon>
          Export
        </v-btn>
      </div>


      <div class="d-flex justify-space-between align-center">
        <template v-if="showReportTypeToggle">
          <span class="inactive_offer_text px-4">
            {{isConversionReport ? "Conversion Report" : "Click Report"}}
          </span>
          <v-switch
            v-model="isConversionReport"
            :loading="isLoadingReportData"
            :disabled="isLoadingReportData"
          >
          </v-switch>
        </template>
        <span class="inactive_offer_text px-4" v-if="user[0].can('see_blacklisted')">Show Blacklisted</span>
        <v-switch
                v-model="isShowBlacklisted"
                v-if="user[0].can('see_blacklisted')"
        >
        </v-switch>
        <span
            class="inactive_offer_text px-4"
            v-if="user[0].can('reports_both_POV')"
        >{{this.onlyAggregatedStats ? "Affiliate  POV": "Advertiser POV"}}</span>
        <v-switch
            v-model="onlyAggregatedStats"
            v-if="user[0].can('reports_both_POV')"
        >
        </v-switch>
      </div>
    </v-container>
    <v-tabs class="reports_tabs" v-model="activeTab" @change="tabChange" show-arrows>
      <v-tab :key="tab.name" v-for="tab in tabs">{{tab.name}}</v-tab>
      <v-tab-item :key="tab.name" v-for="(tab, index) in tabs">
        <ReportTab
            v-if="index === activeTab"
            :key="`${tab.name}-${version}`"
            :name="tab.name"
            :params="tab.params"
            :additionalColumns="tab.additionalColumns"
            :isShowBlacklisted="isShowBlacklisted"
            :version="version"
            :reportType="reportType"
            @loading-started="isLoadingReportData = true"
            @loading-complete="isLoadingReportData = false"
        />

      </v-tab-item>
    </v-tabs>
    <ExportSettings
            :isShow="isExportSettingsDialogOpen"
            :headers="currentFields"
            :example="{}"
    >
    </ExportSettings>
  </div>
</template>

<script>
  import MainLayout from "../../layouts/MainLayout"
  import ReportTab from "./tabsReports/ReportTab"
  import ExportSettings from "./modals/ExportSettings";
  import {mapState} from "vuex";
  import store from "@/store";
  import affiliates from "@/api/affiliates";

  export default {
    components: {
      ReportTab,
      ExportSettings,
    },
    props: {
      version: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        activeTab: 0,
        isExportSettingsDialogOpen: false,
        currentFields: [],
        isConversionReport: false,
        isLoadingReportData: false,
        platform: null,
        commonHeaders: [
          'uvs',
          'clicks',
          'registrations',
          'installations',
          'sales',
          'reg_tp',
          'conversions',
          'total_paid',
          'epc',
          'avg_cost',
          'cost',
          'revenue',
          'margin',
          'profit',
          'sales_ratio',
          'uvs_sales_ratio'
        ],
        tabs: [
          {
            name: 'Offers',
            params: {key: 'offers', name: 'Offer', value: 'offer', type: 'offer_id', entity: 'offer_id', breadCrumbs: [], id: 'offers'},
            additionalColumns: [{text: 'Advertiser', value: 'advertiser', sortKey: 'advertiser_id'}]
          },
          {
            name: 'Campaigns',
            params: {key: 'campaign', name: 'Campaign', value: 'campaign', type: 'campaign_id', entity: 'campaign_id', breadCrumbs: [], id: 'campaign'},
            additionalColumns: [{text: 'Affiliate', value: 'affiliate', sortKey: 'affiliate_id'}]
          },
          {
            name: 'Affiliates',
            params: {key: 'affiliate', name: 'Affiliate', value: 'affiliate', type: 'affiliate_id', entity: 'affiliate_id', breadCrumbs: [], id: 'affiliate'},
            additionalColumns: [{text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'}]
          },
          {
            name: 'Programs',
            params: {key: 'program', name: 'Program', value: 'program', type: 'program_id', entity: 'program_id', breadCrumbs: [], id: 'program'},
          },
          {
            name: 'Advertisers',
            params: {key: 'advertiser', name: 'Advertiser', value: 'advertiser', type: 'advertiser_id', entity: 'advertiser_id', breadCrumbs: [], id: 'advertiser'}
          },
          {
            name: 'AM',
            params: {key: 'affiliate_manager', name: 'AM', value: 'affiliate_manager', type: 'affiliate_manager_id', entity: 'affiliate_manager_id', breadCrumbs: [], id: 'affiliate_manager'}
          },
          {
            name: 'BD',
            params: {key: 'advertiser_manager', name: 'BD', value: 'advertiser_manager', type: 'advertiser_manager_id', entity: 'advertiser_manager_id', breadCrumbs: [], id: 'advertiser_manager'}
          },
          {
            name: 'Geo',
            params: {key: 'geo', value: 'geo', name: 'GEO', type: 'geo', entity: 'geo', breadCrumbs: [], id: 'geo'}
          },
          {
            name: 'Hour',
            params: {key: 'hour', value: 'hour', name: 'Hour', type: 'hour', entity: 'hour', breadCrumbs: [], id: 'hour'}
          },
          {
            name: 'Day',
            params: {key: 'day', value: 'day', name: 'day', type: 'day', entity: 'day', breadCrumbs: [], id: 'day'}
          },
          {
            name: 'Week',
            params: {key: 'week', value: 'week', name: 'week', type: 'week', entity: 'week', breadCrumbs: [], id: 'week'}
          },
          {
            name: 'Device',
            params: {key: 'device', value: 'device', name: 'Device', type: 'device', entity: 'device', breadCrumbs: [], id: 'device'}
          },
          {
            name: 'Verticals',
            params: {key: 'vertical_name', value: 'vertical_name', name: 'vertical_name', type: 'vertical_name', entity: 'vertical_name', breadCrumbs: [], id: 'vertical_name'}
          },
          // {
          //   name: 'Image',
          //   params: {key: 'img', value: 'img', name: 'img', type: 'img', entity: 'img', breadCrumbs: [], id: 'img'}
          // },
          // {
          //   name: 'Keyword',
          //   params: {key: 'kw', value: 'kw', name: 'kw', type: 'kw', entity: 'kw', breadCrumbs: [], id: 'kw'}
          // }
        ],
        onlyAggregatedStats: true,
        isShowBlacklisted: false,
      }
    },
    mounted() {
      document.title = `Reports-${this.$route.params.type?this.$route.params.type:'Offers'}`;
      this.setCurrentFields();
      this.loadPlatform();
      if (this.user[0].can('reports_both_POV')
          || this.user[0].can('reports_affiliates_POV')
      ) {
        this.onlyAggregatedStats = true
      }
      if(!this.$route.params.type) {
        this.$router.push(`${this.basePath}/offers`);
      } else {
        let notFound = true;
        for (let i = 0; i < this.tabs.length; i++) {
          if (this.$route.params.type === this.tabs[i].name.toLowerCase()) {
            this.activeTab = i;
            notFound = false;
            break;
          }
        }
        if (notFound) {
          this.$router.push('/404')
        }
      }
    },
    watch: {
      onlyAggregatedStats: async function () {
        await store.dispatch('reports/saveOnlyAggregatedStats', {
          onlyAggregatedStats: !this.onlyAggregatedStats
        })
      },
      isShowBlacklisted: function () {
        console.log('grand', this.isShowBlacklisted)
      },
      activeTab: function () {
        document.title = `Reports-${this.$route.params.type}`;
        this.setCurrentFields();
      }
    },
    computed: {
      ...mapState('user', ['user']),
      reportType() {
        return this.isConversionReport ? 'conversion' : 'click';
      },
      basePath() {
        if (this.version === 'V3') {
          return '/analytics/reportsV3';
        }
        if (this.version === 'V4') {
          return '/analytics/reportsV4';
        }
        return '/analytics/reports';
      },
      isPlatform1() {
        return Number(this.platform) === 1;
      },
      showReportTypeToggle() {
        return this.isPlatform1;
      }
    },
    methods: {
      async loadPlatform() {
        this.platform = await affiliates.getPlatform();
      },
      tabChange(id) {
        this.$router.push({
          path: `${this.basePath}/${this.tabs[id].name.toLowerCase()}`
        });
      },
      exportReports() {
        this.isExportSettingsDialogOpen = !this.isExportSettingsDialogOpen;
      },
      setCurrentFields() {
        const currentTab = this.tabs[this.activeTab];
        this.currentFields.length = 0;
        if (currentTab) {
          try {
            const selectedFileds = JSON.parse(localStorage.getItem(`fields-${currentTab.name.toLowerCase()}`));
            this.currentFields = selectedFileds && Array.isArray(selectedFileds)
                    ? [...this.commonHeaders].filter(ch => selectedFileds.includes(ch))
                    : [...this.commonHeaders];
            this.currentFields.unshift(currentTab.name.toLowerCase());
          } catch (e) {
            console.log(e.message)
          }
        }
      }
    }
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/styles.sass'
  .none-tab
    pointer-events: none
    opacity: 0.3
  .title_page
    position: relative
    padding-top: 10px
    display: inline
  .export-btn
    display: inline
    margin-left: 3%
  .report_section
    min-width: 250px
  .reports_tabs.theme--light.v-tabs>.v-tabs-bar
      background-color: var(--v-tertiary-base)
      border-radius: 4px
      width: fit-content
      margin-left: 120px
      margin-bottom: 10px
      padding: 5px
  .v-tabs-slider-wrapper
    display: none
  .reports_tabs.theme--light.v-tabs>.v-tabs-bar .v-tab
    text-transform: capitalize
    font-weight: 600
    font-size: 16px
    color: var(--v-accent-darken2) !important
    position: relative
    padding: 0 30px
    &:last-child
      &::after
        display: none
    &::after
      position: absolute
      top: 2px
      right: 0px
      display: block
      content: ''
      width: 1px
      height: 32px
      background-color: var(--v-accent-darken2)
  .reports_tabs.theme--light.v-tabs>.v-tabs-bar .v-tab--active
    color: #fff !important
    background-color: var(--v-primary-base) !important
    border-radius: 4px
  .v-tab--active.v-tab:not(:focus):before
    background-color: var(--v-primary-base)

</style>
